module.exports = __webpack_public_path__ + "img/build_it.feb41b15.svg";